
/// NeoPenStore
export enum PenState {
	disconnected = 'disconnected',
	connecting = 'connecting',
	connected = 'connected'
};
